import axios from 'axios'

// let baseUrl = 'http://localhost:7901/server'
let baseUrl = 'https://pests.warnny.com/server'

// 创建axios实例
const service = axios.create({
    baseURL: baseUrl,
    timeout: 10000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/json'
        return config
    },
    error => {
        // Do something with request error
        console.log(error) // for debug
        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        return Promise.reject(error)
    }
)
export default service
